<template>
	<div class="basic_wrap">
		<div class="red_top_bg">
			<div class="back_left" @click="$router.back()"></div>
			<div class="big_tit">{{$t('shopd.otitle')}}</div>
			<!-- <div class="top_right" @click="$router.push('/moneybag')">
				<van-icon name="bars" size="25"/>
			</div> -->
		</div>
		<div class="head-tabs shadow">
		    <a href="#/ordering" class="tab-item ">{{$t('shopd.Ordering')}}</a>
		    <a href="#/ordered" class="tab-item ">{{$t('shopd.done')}}</a>
		    <a href="#/ordersettle" class="tab-item active">{{$t('c3.settlement')}}</a>
		    <a href="#/orderfrezee" class="tab-item ">{{$t('c3.frezee')}}</a>
		</div>
	<!-- 	<div v-if="data" class="empty" >
		    <div class="image"><img src="../images/shop2/empty.png"></div>
		    <a href="#/grap" class="basic_btn">{{$t('shopd.grabbing')}}</a>
		</div> -->
		
		
		<van-empty :description="$t('orders.noOrders')" v-if="!list" />
		<div v-if="!list" class="basic_btn" @click="$router.push('/grap')">{{$t('shopd.grabbing')}}</div>
		
		<div  class="order_list1" v-if="list" v-for="i in list" >
		    <div  class="list_top1">
		        <img :src="i.pic">
		        <div  class="list_text1">
		            <span>{{i.title}}</span>
		            <div>
		                <p >{{i.price}}</p>
		                <p >X1</p>
		            </div>
		        </div>
		    </div>
		    <div  class="list_down1">
		        <div  class="list_down">
					<div >
					    <span>{{$t('shopds.onum')}}</span>
					    <span>{{i.no}}</span>
					</div>
		            <div >
		                <span>{{$t('shopds.money')}}</span>
		                <span>{{i.price}}</span>
		            </div>
					<div >
					    <span>{{$t('shopds.needba')}}</span>
					    <span>{{i.need}}</span>
					</div>
		            <div >
		                <span>{{$t('shopds.income')}}</span>
		                <span  style="color: rgb(255, 83, 83);">{{i.fee}}</span>
		            </div>
				
		          <!--  <div >
		                <span>{{$t('shopds.numtask')}}</span>
		                <span>{{i.level}}</span>
		            </div> -->
		            <div >
		                <span>{{$t('shopds.time')}}</span>
		                <span>{{i.ct}}</span>
		            </div>
					<div class="notice" v-if="i.stat==98 || (i.stat==99 && i.pay=='0')">
						<span>
							<van-badge color="#d2d214" content="Frezee" />
						</span>
						<span><van-icon name="warning-o" size="20" color="#d2d214"/></span>
					</div>
					<div class="notice" v-if="i.stat==0">
						<span>
							<van-badge color="#999" content="Undo" />
						</span>
						<span><van-icon name="warning-o" size="20" color="#999"/></span>
					</div>
					<div  v-if="i.stat==100 || i.stat==101">
						<span>
							<van-badge color="#3f9a43" content="Completed" />
						</span>
						<span><van-icon name="passed" size="20" color="#3f9a43"/></span>
					</div>
		        </div>
		        <div v-if="i.stat==50" class="basic_btn" @click.stop="data = i;show = true">{{$t('shopd.completeorder')}}</div>
		    </div>
		</div>
		<div v-if="data" class="payment-all">
		    <div>Amount: $  {{data.price}}</div>
		    <div>
		        <button class="btnsub" @click.stop="show = true">
		            {{$t('shopd.completeorder')}}
		        </button>
		    </div>
		</div>
		<div  v-if="data" class="payment-time">
		    <div>Payment countdown: 
		        <van-count-down style="display: initial; font-size: 12px; " :auto-start='true' :time="time" format="HH:mm:ss" />
		    </div>
		</div>
		
		
		<van-overlay :show="show" @click="show = false">
		  <div class="wrapper" @click.stop>
		    <div class="pop_box" v-if="data">
		        <div class="order_cards" >
		            <div  class="order_list1" >
		                <div  class="list_top1">
		                    <img :src="data.pic">
		                    <div  class="list_text1">
		                        <span>{{data.title}}</span>
		                        <div>
		                            <p >{{data.price}}</p>
		                            <p >X1</p>
		                        </div>
		                    </div>
		                </div>
		                <div  class="list_down1">
		                    <div  class="list_down">
		            			<div >
		            			    <span>{{$t('shopds.onum')}}</span>
		            			    <span>{{data.no}}</span>
		            			</div>
		                        <div >
		                            <span>{{$t('shopds.money')}}</span>
		                            <span>{{data.price}}</span>
		                        </div>
								<div >
								    <span>{{$t('shopds.needba')}}</span>
								    <span>{{data.need}}</span>
								</div>
		                        <div>
		                            <span>{{$t('shopds.income')}}</span>
		                            <span  style="color: rgb(255, 83, 83);">{{data.fee}}</span>
		                        </div>
		                        <div >
		                            <span>{{$t('shopds.numtask')}}</span>
		                            <span>{{data.level}}</span>
		                        </div>
		                        <div >
		                            <span>{{$t('shopds.time')}}</span>
		                            <span>{{data.ct}}</span>
		                        </div>
		                    </div>
		                </div>
		            </div>
		        </div>
		    	<div class="capital_evaluate">
		    		<span>{{$t('shopds.score')}}</span>
		    		<van-rate v-model="star" clearable />
		    	</div>
		        <div class="pop_but"  @click="doorder()">
		            <span><span>{{$t('shopds.deal')}}</span></span>
		        </div>
		        <div class="pop_but second" @click="show = false">
		            <span><span>{{$t('shopd.cancelbtn')}}</span></span>
		        </div>
		    </div>
		  </div>
		</van-overlay>
	</div>
</template>

<script>
	import Vue from "vue";
	import {
		Empty
	} from "vant";
    var _that;
	import {
		Dialog,Rate,Overlay,Badge
	} from 'vant';
	import Fetch from "../../utils/fetch";
	Vue.use(Empty)
	.use(Rate)
	.use(Badge)
	.use(Overlay);
	export default {
		name: "ordering",
		data() {
			return {
				lang: this.$i18n.locale || "zh_cn",
				data:null,
				list:null,
				show:false,
				star:0,
				time:0,
				doing:0
			};
		},
		created() {
			this.$parent.footer("ordering");
		},
		mounted() {
			this.start();
			_that = this;
		},
		beforeDestroy() {
		    _that.doing = 0;
		},
		methods: {
			start() {
				Fetch("/user/ordersettle").then((r) => {
					if(r.data && r.data.length>0){
						this.list = r.data;
						var data = r.data[0];
						if(data.stat==50){
							var currentTimestamp = Date.now()/1000;
							var time = (data.rt-currentTimestamp)*1000;
							if(time<0){
								time=0;
							}
							this.time=time;
							this.data = data;
						}
					}
				});
			},
			doorder(){
				if(this.star<3){
					this.$toast({
						duration:'3000',
						background: '#07c160',
						message: this.$t('shopds.lowscore')
					});
					return false;
				}
				
				Fetch("/user/doorder", {
				  id: this.data.id
				}).then(r => {
					// showDialog({
					//   message: this.$t('shopd.corder'),
					//   theme: 'round-button',
					// }).then(() => {
					//   this.$router.push('/grap');
					// });
					this.show = false;
					this.$toast({
						duration:'3000',
						background: '#07c160',
						message: this.$t('shopd.corder')
					});
					this.$router.push('/grap');
				}).catch(err=>{
					if(err && err.code==0 && err.data && err.data.need){
						Dialog.confirm({
							title: 'Tips',
							confirmButtonText:this.$t('moneybag.recharge'),
							cancelButtonText:this.$t('shopd.cancelbtn'),
							message: this.$t('shopds.need') + " " +this.utils_moneyMark()+ err.data.need.toFixed(2)
						})
						.then(() => {
						  this.$router.push('/invest');
						})
						.catch(() => {
						});
					}
				})
			},
			receiveRewards(item){
				var index = -1;
				 for(var i=0;i<this.data.list.length;i++){
					if(this.data.list[i].id==item.id){
						index =i;
					}
				}
				
				Fetch("/index/receiveRewards", {
				  id: item.id
				}).then(r => {
					Dialog.alert({
						message: window.vm.$i18n.t('item.getincome')+ r.data.price,
						confirmButtonText: window.vm.$i18n.t('utils.confirm')
					});
					
					this.data.list[index].isling = '0'
					var sysdate = new Date(r.data.sys_date);
					var millSeconds = Math.abs(sysdate) + (1000*60*60*24-1);
					var date1 = new Date(millSeconds);
					var M = (date1.getMonth()+1 < 10 ? '0'+(date1.getMonth()+1) : date1.getMonth()+1) + '-';		
					var sysTime = sysdate.getFullYear() + '-' + M + sysdate.getDate() + ' '+ sysdate.getHours() + ':' + sysdate.getMinutes() + ':' + sysdate.getSeconds();			 
					var countTime = date1.getFullYear() + '-' + M + date1.getDate() + ' '+ date1.getHours() + ':' + date1.getMinutes() + ':' + date1.getSeconds();
					this.data.list[index].sys_time = sysTime;
					this.data.list[index].count_time = countTime;
				}).catch(err=>{
					Dialog.alert({
						message: window.vm.$i18n.t('item.getincomefail'),
						confirmButtonText: window.vm.$i18n.t('utils.confirm')
					});
				})
			}
		},
	};
</script>

<style lang="less" scoped>
	.red_top_bg {
		
	}

	.money_box {
		display: flex;
		justify-content: space-around;
		border-radius: 10px;
		padding: 10px;
		margin: 10px;
		color:#36333d;
		background: #FFF;

		.item {
			width: 33.33%;
			text-align: center;
			font-weight: bold;

			.money_num {
				font-size: 18px;
				line-height: 25px;
				white-space: normal;
				word-break: normal;
				text-align: center;
			}

			.info {
				font-size: 12px;
				line-height: 20px;
				font-weight: normal;
				margin-top: 5px;
			}
		}
	}

	.notes_tit {
		line-height: 44px;
		height: 44px;
		font-size: 14px;
		color: #000000;
		padding: 0 14px;
		background: #FAFAFA;
		z-index: 2;
		margin: 10px;
		border-radius: 5px;
	}

	.notes_box {
		width: 100%;
		padding-bottom: 2px;
		background: rgba(255, 255, 255, 1);
		box-shadow: 0px 2px 9px 2px rgba(160, 160, 160, 0.15);
		border-radius: 6px;
		margin-bottom: 10px;

		.timer {
			padding: 3px 3px;
			font-size: 12px;
			color: rgba(0, 0, 0, .6);
			border-bottom: 1px solid #ececec;
			display: flex;
			justify-content: space-between;
			align-items: center;

			span {
				font-style: normal;
				padding: 5px;
				border-radius: 5px;
				color: #FFFFFF;
			}

			.ing {
				background: #3775f4;
			}

			.finish {
				font-style: normal;
				background: #07c160;
			}
		}

		.item_div1 {
			display: flex;
			justify-content: space-between;
			padding: 15px 10px;

			p:nth-child(1) {
				width: 100%;
				font-weight: bold;
				overflow: hidden;
				text-overflow: ellipsis;
				white-space: nowrap;

			}
		}

		.item_div2 {
			display: flex;
			justify-content: space-between;
			text-align: center;
			margin-bottom: 5px;
			margin-top: 5px;
			div {
				width: 33.33%;

				p {
					padding: 5px 0;
				}
			}

			.item_rate {
				p:nth-child(1) {
					font-weight: bold;
					font-size: 14px;
					color: #FF0000;

				}

				p:nth-child(2) {
					color: #999;
				}
			}

			.item_day {
				p:nth-child(1) {
					font-weight: bold;
					font-size: 14px;

				}

				p:nth-child(2) {
					color: #999;
				}
			}

			.item_min {
				p:nth-child(1) {
					font-weight: bold;
					font-size: 14px;

				}

				p:nth-child(2) {
					color: #999;
				}
			}
		}
	}

	.scrollBox {
		width: 96%;
		margin-left: 2%;
	}
	
	.head-tabs {
	    height: 50px;
	    padding: 15px;
	    background: #FFF;
	    white-space: nowrap;
		border-radius: 10px;
		text-align: center;
		margin: 10px;
		.tab-item {
		    z-index: 0;
		    position: relative;
		    height: 16px;
		    line-height: 16px;
		    font-size: 14px;
		    color: #37475a;
		    transition: all .3s ease;
		}
		.tab-item:after {
		    z-index: -1;
		    content: "";
		    position: absolute;
		    left: 0;
		    right: 0;
		    bottom: 0;
		    height: 4px;
		    border-radius: 2px;
			
		}
		.active {
		    font-size: 1.2em;
		    color: #fc494d;
			:after {
			    background: #ff8c46;
			}
		}
		.tab-item.active:after {
		    background: #ff8c46;
		}
		.tab-item+.tab-item {
		    margin-left: 20px;
		}
	}
	.box {
		margin: 3vw;
		border-radius: 2vw;
		overflow: hidden;
	    background-color: rgb(12, 109, 86);
		padding: 0;
		color: #FFF;
		.header1 {
		    display: flex;
		    padding: 0 10px;
		    height: 40px;
		    line-height: 40px;
		    font-size: 14px;
			background: none;
			border-bottom: none;
			color: #FFF;
			.id {
			    font-weight: bold;
				color: #FFF;
			}
			.time {
			    flex: 1;
			    text-align: right;
			    color: #999;
			    font-size: 10px;
				color: #FFF;
			}
		}
		.button {
		    display: block;
		    padding: 0 10px;
		    border-radius: 5px;
		    height: 40px;
		    line-height: 40px;
		    font-size: 16px;
		    color: #FFF;
		    text-align: center;
		    background: linear-gradient(180deg, #36333d, #746b0a);
		    overflow: hidden;
		    cursor: pointer;
		}
		.content {
		    display: flex;
		    padding: 0 10px 10px;
			.left {
			    border-radius: 3vw;
			    width: 90px;
			    height: 90px;
			    padding: 2px;
			    text-align: center;
			    background-color: #75777a;
			    overflow: hidden;
				img {
				    border-radius: 3vw;
				    width: 90px;
				    height: 90px;
				}
			}
			.right {
			    position: relative;
			    flex: 1;
			    padding-left: 10px;
			    line-height: 20px;
				.title {
				    margin-bottom: 10px;
				    height: 40px;
				    font-weight: 500;
				    overflow: hidden;
				}
				 .price,.earnings {
				    color: #aaa;
					 em {
						font-style: normal;
						font-size: 16px;
						font-weight: bold;
						color: #e5ae2f;
					}
				}
			}
			.button {
			    display: block;
			    padding: 0 10px;
			    border-radius: 5px;
			    height: 40px;
			    line-height: 40px;
			    font-size: 18px;
			    color: #202226;
			    text-align: center;
			    background: linear-gradient(180deg, #36333d, #746b0a);
			    overflow: hidden;
			    cursor: pointer;
			}
		}
	}
	.empty{
		text-align: center;
		background-color: #fc494d;
		border-radius: 10px;
		padding: 15px;
		margin: 10px;
		img {
			margin: 30px auto;
			height: 180px;
			border-radius: 1.5em;
		}
		.button {
		    display: block;
		    padding: 0 10px;
		    border-radius: 5px;
		    height: 40px;
		    line-height: 40px;
		    font-size: 16px;
		    color: #FFF;
		    text-align: center;
		    background: linear-gradient(180deg, #36333d, #746b0a);
		    overflow: hidden;
		    cursor: pointer;
			display: inline-block;
			padding: 0 20px;
			width: 80%;
		}
	}
	
	.order_list1{
	    background-color: #fff;
	    padding: 10px;
		margin: 10px;
	    border-radius: 10px;
	    box-shadow: 0 4px 4px rgba(0,0,0,.05);
		.list_top1{
		    width: 100%;
		    height: 90%;
		    border-bottom: 1px dashed gray;
		    display: flex;
		    justify-content: space-between;
		    padding: 5px 0;
			img{
			    max-width: 100px;
			    max-height: 100px;
			    border-radius: 10px;
			}
			.list_text1{
			    width: 60%;
			    display: flex;
			    justify-content: space-between;
			    flex-direction: column;
				> span:first-child {
				    display: block;
				    font-size: 12px;
				    color: #37475a;
				    overflow: hidden;
				    text-overflow: ellipsis;
				    -webkit-line-clamp: 4;
				    display: -webkit-box;
				    -webkit-box-orient: vertical;
					line-height: 1.5em;
				}
				 > div {
				    display: flex;
				    justify-content: space-between;
				    align-items: center;
				    margin: 3% 0;
				    color: #232f3e;
				    font-size: 17px;
				    font-weight: 600;
					> p:last-child {
					    color: #034aff;
					    font-size: 12px;
					}
				}
			}
		}
		.list_down{
		    /* height: 50%; */
		    display: flex;
		    flex-direction: column;
		    justify-content: space-between;
		    font-size: 13px;
		    padding: 5px 0;
			> div{
			    display: flex;
			    justify-content: space-between;
			    align-items: center;
			    color: #37475a;
			    height: 20px;
				> span:last-child {
				    color: #232f3e;
				    font-size: 13px;
				}
			}
		}
		.list_down1{
		    height: auto;
		    text-align: end;
			font-size: 16px;
		}
	}
	.basic_btn{
		margin: 1.5em auto;
		height: 38px;
		line-height: 38px;
		font-size: 14px;
	}
	
	.pop_box{
	    width: 90%;
	    max-width: 600px;
	    padding: 5px;
	    position: relative;
	    border-radius: 10px;
	    background-image: linear-gradient(#fca120,#fff);
		.pop_but{
		    width: 96%;
		    margin: 4% 2%;
		    height: 41px;
		    border-radius: 10px;
		    display: flex;
		    align-items: center;
		    justify-content: center;
		    background-color: #232f3e;
		    color: #ffcd00;
			font-size: 1.3em;
		}
		.capital_evaluate{
			width: 100%;
			height: auto;
			padding: 10px;
			font-size: 1.3em;
			>span{
				margin-right: 3%;
			}
		}
		.second{
		    background-color: #d9d9d9;
		    color: #37475a;
		}
	}
	.wrapper {
	    display: flex;
	    align-items: center;
	    justify-content: center;
	    margin-top: 15vh;
	}

	/deep/ .van-overlay{
		position: absolute;
	}
	.basic_wrap{
		position: relative;
		padding-bottom: 100px;
		height: 100vh;
		overflow: scroll;
	}
	
	.payment-all {
		position: fixed;
		justify-content: space-between;
		z-index: 1;
		display: flex;
		bottom: 100px;
		width: 100%;
		height: 60px;
		left: 0;
		transition: all ease 0.5s;
		-webkit-transition: all ease 0.5s;
		-moz-transition: all ease 0.5s;
		-ms-transition: all ease 0.5s;
		background: rgba(255, 255, 255, 0.80);
		box-shadow: 0px -3px 10px rgba(0, 0, 0, 0.1);
		-webkit-box-shadow: 0px -3px 10px rgba(0, 0, 0, 0.1);
		-moz-box-shadow: 0px -3px 10px rgba(0, 0, 0, 0.1);
		-ms-box-shadow: 0px -3px 10px rgba(0, 0, 0, 0.1);
		-webkit-backdrop-filter: saturate(125%) blur(10px);
		-moz-backdrop-filter: saturate(125%) blur(10px);
		-ms-backdrop-filter: saturate(125%) blur(10px);
		backdrop-filter: saturate(125%) blur(10px);
		line-height: 60px;
	}


	.payment-all > div {
		padding: 0 20px;
		display: table;
	}

	.payment-all > div > button {
		vertical-align: middle;
		display: table-cell;
	}
	.payment-time{
		position: fixed;
		justify-content: space-between;
		z-index: 1;
		display: flex;
		bottom: 60px;
		width: 100%;
		height: 40px;
		line-height: 40px;
		left: 0;
		transition: all ease 0.5s;
		-webkit-transition: all ease 0.5s;
		-moz-transition: all ease 0.5s;
		-ms-transition: all ease 0.5s;
		background: rgba(255, 255, 255, 0.80);
		box-shadow: 0px -3px 10px rgba(0, 0, 0, 0.1);
		-webkit-box-shadow: 0px -3px 10px rgba(0, 0, 0, 0.1);
		-moz-box-shadow: 0px -3px 10px rgba(0, 0, 0, 0.1);
		-ms-box-shadow: 0px -3px 10px rgba(0, 0, 0, 0.1);
		-webkit-backdrop-filter: saturate(125%) blur(10px);
		-moz-backdrop-filter: saturate(125%) blur(10px);
		-ms-backdrop-filter: saturate(125%) blur(10px);
		backdrop-filter: saturate(125%) blur(10px);
	}
	.payment-time > div {
		padding: 0 20px;
		display: table;
	}
	.btnsub{
		height: 25px;
		line-height: 20px;
		padding: 2px 8px;
		border-radius: 5px;
		margin-left: 10px;
		font-size: 12px;
		box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 6px -1px, rgba(0, 0, 0, 0.1) 0px 2px 4px -2px;
		background-color: #232f3e;
		color: #ffcd00;
	}
</style>
